
<template>
  <div>
    <el-dialog
      custom-class="MyDialog"
      :title="$t('app.emergencyContactSettingsTitle')"
      :visible.sync="dialogEmergency"
      :close-on-click-modal="false"
      @close="cancelEmergency"
      width="575px"
    >
      <p>{{ $t('app.auto_265_edec6409') }}</p>
      <p>{{ $t('app.auto_266_ec12174c') }}</p>
      <div class="select_staff">
        <span class="text_block">{{ $t('app.auto_267_825914e3') }}</span>
        <el-select 
          v-model="valueStaff" 
          multiple 
          filterable
          :multiple-limit="2"
          :placeholder="$t('app.pleaseSelect')" 
          @change="selectStaff"
          style="width: 100%"
          >
          <el-option
            v-for="item in optionsStaff"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            >
          </el-option>
        </el-select>
      </div>

      <el-table 
        :data="tableDataEmergency"
        border
        :header-cell-style="{
          background: 'rgb(230, 240, 252)',
          textAlign: 'center',
          color: 'black',
          borderRight: '2px solid #fff',
        }"
        :cell-style="{
          textAlign: 'center',
          padding: '0',
        }"
        style="width: 100%"
      >
          <template slot="empty">
              <el-empty  :description="$t('app.auto_264_fc834024')" :image-size="30"></el-empty>
          </template>
          <el-table-column prop="index" :label="$t('app.label')"></el-table-column>
          <el-table-column prop="name" :label="$t('app.label')"></el-table-column>
          <el-table-column prop="phone" :label="$t('app.label')"></el-table-column>
          <el-table-column prop="ddNum" :label="$t('app.label')"></el-table-column>
      </el-table>

      <div style="display: flex">
        <p class="text_gap">{{ $t('app.auto_268_670ff28c') }}</p>
        <el-switch
          v-model="switchEmergencyValue"
          active-color="#3d76e0"
          inactive-color="#e4e7e9">
        </el-switch>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-divider></el-divider>
        <el-button @click="submitEmergency" type="primary">{{ $t('app.submit') }}</el-button>
        <el-button @click="cancelEmergency">{{ $t('app.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LoginUserHelper from "@/util/LoginUserHelper";
import { queryAccountCenterList } from "@/api/AddEmpolyee";
import { queryEmergencyContactList, updEmergencyContact } from '@/api/AccountInterface';

export default {
  data() {
    return {
      tableDataEmergency: [
        {
          index: this.$t('app.auto_265_2be97a89'),
          name: this.$t('app.auto_266_16011053'),
          phone: this.$t('app.auto_267_38444dd7'),
          ddNum: this.$t('app.auto_268_eb95a4e9'),
        },
        {
          index: this.$t('app.auto_269_e283a2e6'),
          name: this.$t('app.auto_270_d8e63225'),
          phone: this.$t('app.auto_271_2affd119'),
          ddNum: this.$t('app.auto_272_1f9e7cf3'),
        },
      ],
      valueStaff: [],
      switchEmergencyValue: false,
      optionsStaff: [],
      dialogEmergency: false,
      campusId: LoginUserHelper.getUserInfo().campusId,
      allStaffList: []
    };
  },
  methods: {
    async init(){
      await this.queryEmergencyContactList();
      await this.queryAccountCenterList();
    },
    async queryAccountCenterList() {
      let params = {
        campusId: this.campusId
      };
      let { data, code, message } = await queryAccountCenterList(params)
      if (code === 0) {
        this.allStaffList = data;
        this.optionsStaff = data.map(item => {
          return {
            value: item.account_id,
            label: item.real_name
          };
        });
        // 默认选中状态
        // 列表中会返回两条“未设置”数据需要过滤掉
        this.valueStaff = this.tableDataEmergency.filter(item => item.accountId > 0).map(item => item.accountId);
      } else {
        this.$message.error(this.$getCodeMessage(code, message))
      }
    },
    async queryEmergencyContactList() {
      try {
        const { data, code, message } = await queryEmergencyContactList({ campusId: this.campusId });
        
        if (code === 0) {
          this.tableDataEmergency = this.formatEmergencyContacts(data?.contactList || []);
          this.switchEmergencyValue = data?.isShow === 1;
        } else {
          throw new Error(message);
        }
      } catch (error) {
        this.$message.error(this.$t('app.auto_273_aeb07a52'));
        this.tableDataEmergency = this.getDefaultEmergencyContacts();
        this.switchEmergencyValue = false;
      }
    },

    formatEmergencyContacts(contactList) {
      if (contactList.length === 0) {
        return this.getDefaultEmergencyContacts();
      }
      return contactList.map((item, index) => ({
        index: `紧急联系人${index + 1}`,
        name: item.accountTrueName || this.$t('app.auto_274_b45d5bf5'),
        phone: item.accountPhone || this.$t('app.auto_275_08ad640c'),
        ddNum: item.dingPhone || this.$t('app.auto_276_e3c7f90a'),
        userId: item.userId || '',
        accountId: item.accountId || ''
      }));
    },

    getDefaultEmergencyContacts() {
      return [
        { index: this.$t('app.auto_277_db75769c'), name: this.$t('app.auto_278_a241fe24'), phone: this.$t('app.auto_279_63ad186a'), ddNum: this.$t('app.auto_280_4eee9e17'), userId: '', accountId: '' },
        { index: this.$t('app.auto_281_b8fe3ff8'), name: this.$t('app.auto_282_a4143e47'), phone: this.$t('app.auto_283_b21e743a'), ddNum: this.$t('app.auto_284_9b21a54d'), userId: '', accountId: '' }
      ];
    },
    async submitEmergency() {
      let params = {
        campusId: this.campusId,
        isShow: this.switchEmergencyValue ? 1 : 0,
        contactList: this.tableDataEmergency.map((item,index) => {
          return {
            type: index + 1,
            accountId: item.accountId,
            userId: item.userId
          };
        })
      };
      let { data, code, message } = await updEmergencyContact(params)
      if ( code === 0 && data === 1) {
          this.dialogEmergency = false;
          this.$message.success(this.$t('app.auto_285_c5128c5f'));
        } else {
          this.$message.error(this.$t('app.auto_286_e806378c'));
      }
      this.init();
    },
    cancelEmergency() {
      this.dialogEmergency = false;
      this.init();
    },
    selectStaff(value) {     
      // 创建一个Map来快速查找staff成员
      const staffMap = new Map(this.allStaffList.map(staff => [staff.account_id, staff]));
      
      // 创建两个默认的"未设置"联系人
      const defaultContact = { name: this.$t('app.auto_287_849374aa'), phone: this.$t('app.auto_288_2ce03110'), ddNum: this.$t('app.auto_289_78eeb1e3'), userId: "", accountId: "" };
      
      // 使用map和slice来创建结果数组
      this.tableDataEmergency = value.slice(0, 2).map((accountId, index) => {
        const staffMember = staffMap.get(accountId);
        if (staffMember) {
          return {
            index: `紧急联系人${index + 1}`,
            name: staffMember.real_name,
            phone: staffMember.phone,
            ddNum: staffMember.dingPhone,
            userId: staffMember.userId,
            accountId: staffMember.account_id
          };
        }
        return { ...defaultContact, index: `紧急联系人${index + 1}` };
      });

      // 如果选择的联系人少于2个，用默认联系人填充
      while (this.tableDataEmergency.length < 2) {
        this.tableDataEmergency.push({
          ...defaultContact,
          index: `紧急联系人${this.tableDataEmergency.length + 1}`
        });
      }
    },
    removeStaff() {
      this.tableDataEmergency = this.tableDataEmergency.filter(item => {
        return this.valueStaff.includes(item.accountId);
      });
    }
  },
  components: {

  },
  mounted() {
    this.init();
  },
}
</script>

<style lang="scss" scoped>

.MyDialog {
  border-radius: 20px;

  .el-dialog__header {
    background: rgb(74, 131, 232);
    border-radius: 20px 20px 0 0;

    .el-dialog__title,
    .el-dialog__close {
      color: white;
    }
  }

  .dialog-footer {
    button {
      border-radius: 20px;
    }
  }
}

.select_staff {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
  .text_block {
    margin-right: 20px;
    display: inline-block;
    width: 100px;
  }
}

.text_gap {
  margin-right: 20px;
}


::v-deep .MyDialog .el-empty__description{
  margin-top: -10px;
  line-height: 10px;
}
::v-deep .MyDialog .el-dialog__body{
  height: 320px;
  padding: 30px 20px 10px;
}
</style>